import ContactsVue from '@/views/sa/contacts/contacts.vue';

const basePath = '/sa/contacts';
const role = 'sa'; // 角色身份

export const SA_CONTACTS_INDEX = 'sa-contacts-index';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: ContactsVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: SA_CONTACTS_INDEX,
      component: () => import(
        /* webpackChunkName: "chatRoom" */
        `@/views/${role}/contacts/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
